<app-breadcrumb
  *ngIf="!mod"
  [master]="'Dobry Agent'"
  [parentName]="'Tagi'"
  [name]="isEditMode ? 'Edytuj' : 'Dodaj'"
></app-breadcrumb>

<div class="tags-add-container" fxLayout="column" fxLayoutGap="15px">

  <div *ngIf="loading" class="da-tag-form-loader">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <form
    *ngIf="!loading"
    #tagForm="ngForm"
    class="da-tag-form"
    (ngSubmit)="save(tagForm)"
    fxLayout="column"
    fxFlex="100"
    fxFlex.lt-md="100"
    fxLayoutGap="15px"
  >
    <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">

      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="tagForm.invalid || saving"
      >
        <mat-icon>save</mat-icon>
        <span>{{ saving ? ' Zapisywanie...' : ' Zapisz' }}</span>
      </button>

      <button
        *ngIf="!isEditMode && !mod"
        mat-raised-button
        color="accent"
        type="button"
        (click)="save(tagForm, true)"
        [disabled]="tagForm.invalid || saving"
      >
        <mat-icon>save</mat-icon>
        <span> Zapisz i dodaj kolejny</span>
      </button>

      <button
        mat-stroked-button
        type="button"
        (click)="cancel()"
        [disabled]="saving"
        color="warn"
      >
        <mat-icon> cancel </mat-icon>
        <span>{{ mod ? ' Zamknij' : ' Anuluj' }}</span>
      </button>

    </div>

    <mat-card fxLayout="column" fxFlex="100" >
      <app-section-header
        [title]="isEditMode ? 'Edytuj tag' : 'Dodaj tag'"
        [description]="
    isEditMode
      ? 'Zmień podstawowe dane i ustawienia tagu.'
      : 'Uzupełnij podstawowe dane i ustawienia tagu.'
  "
      ></app-section-header>
      <mat-form-field fxFlex="100">
        <mat-label>Nazwa taga</mat-label>

        <input
          matInput
          name="name"
          required
          maxlength="100"
          placeholder="Np. Ubezpieczenia"
          [(ngModel)]="model.name"
          #name="ngModel"
        >

        <mat-error *ngIf="name.errors?.required && name.touched">
          Nazwa taga jest wymagana.
        </mat-error>

        <mat-error *ngIf="name.errors?.backend && name.touched">
          {{ name.errors.backend }}
        </mat-error>
      </mat-form-field>

      <mat-slide-toggle
        color="accent"
        name="active"
        [(ngModel)]="model.active"
      >
        Aktywny
      </mat-slide-toggle>
    </mat-card>

  </form>
</div>
